<template>
    <div class="table-striped" >
      <div class="table-box" v-if="!empty && loadStatusTbl">
        <md-table v-model="items" :table-header-color="tableHeaderColor" :md-sort.sync="currentSort" :md-sort-order.sync="currentSortOrder" :md-sort-fn="customSort">

          <md-table-row  slot="md-table-row" slot-scope="{ item }">
            <md-table-cell md-label="Номер заявки" md-sort-by="id">{{ item.id }}</md-table-cell>
            <md-table-cell md-label="Город" md-sort-by="city">{{ item.city }}</md-table-cell>
            <md-table-cell md-label="ФИО" md-sort-by="name">{{ item.name }}</md-table-cell>
            <md-table-cell  md-label="Номер телефона" md-sort-by="phone">{{ item.phone }}</md-table-cell>
            <md-table-cell md-label="Статус" md-sort-by="status">{{ item.status.name }}</md-table-cell>
            <md-table-cell md-label="Дата создания" md-sort-by="createdAt">{{ dateFormat (item.created_at) }}</md-table-cell>
            <md-table-cell md-label="Дата обновления" md-sort-by="updatedAt">{{ dateFormat (item.updated_at) }}</md-table-cell>
            <md-table-cell md-label="Комментарий" md-sort-by="comment">{{ item.comment }}</md-table-cell>
            <md-table-cell md-label=""><md-icon @click.native="edit(item.id)"  class="md-icon-font-yellow md-theme-default pointer">edit</md-icon></md-table-cell>
          </md-table-row>
        </md-table>
        <div class="pagination-block">
          <paginate
            :page-count="this.getCountPage()"
            :click-handler="changePagination"
            :prev-text="''"
            :next-text="''"
            :value="this.getCurrentPage()"
            :container-class="'pagination pagination-no-border pagination-success pagination-primary'">
          </paginate>
        </div>
      </div>

      <div class="loading-overlay" v-if="!loadStatusTbl">
        <md-progress-spinner :md-stroke="2" md-mode="indeterminate"></md-progress-spinner>
      </div>
      <div class="md-empty-state" v-if="empty">
        <h1>Записей не найдено</h1>
      </div>
    </div>
</template>
<script>
import HttpClient from '@/api/calls'
import FormatDate from '@/format/date'
export default {
  name: 'tbl',
  props: {
    tableHeaderColor: {
      type: String,
      default: ''
    }
  },

  data () {
    return {
      selected: [],
      items: [],
      meta: [],
      empty: true,
      pagination: {
        current_page: 1,
        count_page: 0
      },
      loadStatusTbl: false,
      currentSort: 'createdAt',
      currentSortOrder: 'desc',
      currentSortOld: 'createdAt',
      currentSortOrderOld: 'desc'
    }
  },
  methods: {
    listAll () {
      this.loadStatusTbl = false
      return HttpClient.httpGet('requests.registrationListAll', this.prepareFilters())
    },
    dateFormat (str) {
      return FormatDate.format(str)
    },
    parseResponse (response) {
      if (response.meta) {
        this.meta = response.meta
        this.setCurrentPage(this.meta.pagination['current_page'])
        this.setCountPage(this.meta.pagination['total_pages'])
      }
      if (response.data && response.data.length !== 0) {
        this.items = response.data
        this.empty = false
      } else {
        this.items = []
        this.empty = true
      }
      this.loadStatusTbl = true
    },
    changePagination (pageNum) {
      if (this.getCurrentPage() === pageNum) {
        return
      }
      this.setCurrentPage(pageNum)
      this.refreshData()
    },
    refreshData () {
      const $this = this
      this.listAll()
        .then(function (response) {
          $this.parseResponse(response)
        })
    },
    prepareFilters () {
      let params = {}
      params['page'] = this.getCurrentPage()
      params['filter'] = []
      for (let key in this.$store.state.filters) {
        if (this.$store.state.filters[key] !== null) {
          params['filter'][key] = this.$store.state.filters[key]
        }
      }
      if (this.$store.state.search) {
        params['q'] = this.$store.state.search
      }
      params['order'] = {}
      params['order']['method'] = this.currentSortOrder
      params['order']['input'] = this.currentSort
      return params
    },
    edit (id) {
      this.$store.state.editID = id
      this.$emit('edit')
    },
    customSort (value) {
      if (this.currentSort === this.currentSortOld && this.currentSortOrder === this.currentSortOrderOld) {
        return value
      }
      this.currentSortOld = this.currentSort
      this.currentSortOrderOld = this.currentSortOrder
      this.refreshData()
      return value
    },
    getCurrentPage () {
      if (this.$store.state.pagination.current_page > 0) {
        return this.$store.state.pagination.current_page
      }
      return 1
    },
    setCurrentPage (currentPage) {
      this.$store.state.pagination.current_page = currentPage
    },
    getCountPage () {
      return this.$store.state.pagination.count_page
    },
    setCountPage (countPage) {
      this.$store.state.pagination.count_page = countPage
    }
  },
  async created () {
    const $this = this
    let data = await Promise.resolve($this.listAll())
    if (data) {
      this.parseResponse(data)
    } else {
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/registrationRequests/list/table.vue